import React, { useMemo } from "react";

const MarketFYTable = ({ data }) => {
  // Extract FY Keys dynamically (FY25, FY26…)
  const fyKeys = useMemo(() => Object.keys(data || {}).sort(), [data]);

  // Extract markets dynamically from nested FY objects
  const markets = useMemo(() => {
    const m = new Set();
    fyKeys.forEach((fy) => {
      Object.keys(data[fy] || {}).forEach((market) => m.add(market));
    });
    return Array.from(m).sort();
  }, [data, fyKeys]);

  // Compute totals per FY
  const totals = useMemo(() => {
    const t = {};
    fyKeys.forEach((fy) => {
      t[fy] = { tmsId: 0, e2eId: 0 };
      markets.forEach((market) => {
        const row = data?.[fy]?.[market] || {};
        t[fy].tmsId += row.tmsId || 0;
        t[fy].e2eId += row.e2eId || 0;
      });
    });
    return t;
  }, [data, fyKeys, markets]);

  // Compute Total Count for Accordion Title
  const totalSum = useMemo(() => {
    let sum = 0;
    fyKeys.forEach((fy) => {
      sum += totals[fy].tmsId + totals[fy].e2eId;
    });
    return sum;
  }, [totals, fyKeys]);

  return (
    <div className="accordion" id="marketAccordion">
      
      <div className="accordion-item">
        <h2 className="accordion-header" id="headingOne">
          <button
            className="accordion-button collapsed"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#collapseOne"
          >
            Total # of Projects Closed(Total: {totalSum})
          </button>
        </h2>

        <div
          id="collapseOne"
          className="accordion-collapse collapse"
          data-bs-parent="#marketAccordion"
        >
          <div className="accordion-body">

            <div className="table-responsive">
              <table className="table table-bordered table-striped text-center">
                <thead>
                  <tr>
                    <th rowSpan={2}>Market</th>
                    <th colSpan={fyKeys.length}>TMS ID</th>
                    <th colSpan={fyKeys.length}>E2E ID</th>
                  </tr>
                  <tr>
                    {fyKeys.map((fy) => (
                      <th key={"id1_" + fy}>{fy}</th>
                    ))}
                    {fyKeys.map((fy) => (
                      <th key={"id2_" + fy}>{fy}</th>
                    ))}
                  </tr>
                </thead>

                <tbody>
                  {markets.map((market) => (
                    <tr key={market}>
                      <td>{market}</td>

                      {fyKeys.map((fy) => (
                        <td key={`id1_${fy}_${market}`}>
                          {data?.[fy]?.[market]?.tmsId ?? "--"}
                        </td>
                      ))}

                      {fyKeys.map((fy) => (
                        <td key={`id2_${fy}_${market}`}>
                          {data?.[fy]?.[market]?.e2eId ?? "--"}
                        </td>
                      ))}
                    </tr>
                  ))}

                  <tr className="fw-bold bg-light">
                    <td>Total</td>

                    {fyKeys.map((fy) => (
                      <td key={`total_id1_${fy}`}>{totals[fy].tmsId}</td>
                    ))}

                    {fyKeys.map((fy) => (
                      <td key={`total_id2_${fy}`}>{totals[fy].e2eId}</td>
                    ))}
                  </tr>
                </tbody>
              </table>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default MarketFYTable;
